import React from 'react';
import { Loader } from 'components';

const AsyncBranch = ({ pending, onPending = <Loader large={true} center={true} timeout={0} top={20}/>, error, onError, empty, onEmpty, children }) => {
  if(pending) return onPending;
  if(error) return onError;
  if(empty) return onEmpty || null;
  return children;
}
export default AsyncBranch;


// WEBPACK FOOTER //
// ./src/components/ui/AsyncBranch.jsx